import { render, staticRenderFns } from "./WootKeyShortcutModal.vue?vue&type=template&id=4fe099ec&scoped=true&"
import script from "./WootKeyShortcutModal.vue?vue&type=script&lang=js&"
export * from "./WootKeyShortcutModal.vue?vue&type=script&lang=js&"
import style0 from "./WootKeyShortcutModal.vue?vue&type=style&index=0&id=4fe099ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe099ec",
  null
  
)

export default component.exports